module.exports = __webpack_public_path__ + "img/dock-door-clearance.0df96ba7.svg";